import React from 'react';
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";
import RadioButton from "./RadioBig";
import {trackConversion} from "../utils/analytics";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { Trans } from '../utils/i18n';
import DatepickerStatic from './DatepickerStatic';
import { Field } from 'react-final-form';

export const PurchaseDateSelect = React.memo(function ({ values, mode, form,  }) {
        const orderEntryDispatch = useFormStateDispatch();
        const { selectedCategory, selectedCategoryProduct, selectedPurchaseDate } = useFormState();

        if (!selectedCategory || !selectedCategoryProduct) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        // TODO: Make this dynamic (based on category / product)
        const options = [
            {
                id: "lastYear",
                name: <Trans i18nKey={'component.PurchaseDateSelect.lastYear'}>Device bought in last year</Trans>,
            },
            {
                id: "last3Years",
                name: <Trans i18nKey={'component.PurchaseDateSelect.last3Years'}>Device bought in last 3 years</Trans>,
            },
            {
                id: "last5Years",
                name: <Trans i18nKey={'component.PurchaseDateSelect.last5Years'}>Device bought in last 5 years</Trans>,
            },
            {
                id: "older5Years",
                name: <Trans i18nKey={'component.PurchaseDateSelect.older5Years'}>Device older than 5 years</Trans>,
            },
        ];


        return (
            <div>
                <div className={'grid grid-cols-12 gap-6'}>
                    {
                        options?.map((option) =>
                                <div className={'col-span-6 md:col-span-3'} key={option.id}>
                                    <RadioButton
                                        input={{
                                            checked: selectedPurchaseDate?.id === option.id,
                                            value: option.id,
                                            onChange: (e) => {
                                                orderEntryDispatch({type: 'setSelectedPurchaseDate', value: option});
                                                // TODO: Track conversion
                                                trackConversion({
                                                    action: 'OrderEntryClickPurchaseDateSelect:'+(option.id),
                                                    resourceId: selectedCategoryProduct?.id,
                                                    resourceType: 'App\\Models\\Product'
                                                });
                                            },
                                        }}
                                        field={{
                                            titel: option.name,
                                        }}
                                        meta={{}}
                                    />
                                </div>,
                            )
                    }
                </div>

                {/* <Field
                        name={'day'}
                        component={DatepickerStatic}
                        field={{
                            "name": "day",
                            "label": <Trans i18nKey="appointment.form.day">Day</Trans>,
                            "size": "half",
                            "type": "datepicker",
                            "required": true,
                            "preventWeekends": true,
                            // shouldDisableDate: (date) => !availableDays.includes(dayjs(date).format('YYYY-MM-DD')),
                        }}
                /> */}
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

